import React, { FC } from 'react'

import { isWindowExist } from '@smarty-nx/code-utils'
import { graphql, PageProps } from 'gatsby'

import DataOnlySimPlan from './data-only-sim-plan'
import { CONFIG } from '../../../config'
import { useIsAuthenticated } from '../../../hooks'

const getExistingQueryParams = (search: string): string => {
  if (search.length) {
    return `&${search.substring(1)}`
  }
  return ''
}

type DataOnlyPlansProps = PageProps<Queries.DataOnlyPlansQuery>

/**
 * Authenticate the user and navigates to Data Only Sim Landing Page else redirect to Login page.
 * From SEO perspective we already have public indexable page on '/data-sim' route, where we show
 * prices w/out group discount and Google shows that page by query 'smarty data only sim plans'
 */
const DataOnlyPlans: FC<DataOnlyPlansProps> = ({ data }) => {
  const { awardsSection } = data

  const isAuthenticated = useIsAuthenticated()

  if (isAuthenticated) {
    return <DataOnlySimPlan awardsSection={awardsSection} />
  }
  if (isWindowExist()) {
    window.location.replace(
      `${
        CONFIG.MARKETING_URL
      }login?redirect=/dashboard/groups/data-only-plans${getExistingQueryParams(
        window.location.search
      )}`
    )
  }
  return null
}

export default DataOnlyPlans

export const query = graphql`
  query DataOnlyPlans {
    awardsSection: contentfulPageSection(sectionName: { eq: "awards" }) {
      ...GenericPageSection
    }
  }
`
